// src/services/api.js - PROD FIX v3.0
import axios from "axios";

/**
 * ATENÇÃO: URL da API definida diretamente para produção
 * Se hostname for www.farinhaecia.com.br, usa https://www.farinhaecia.com.br/api
 * Caso contrário, usa localhost
 */
const API_URL = "https://www.farinhaecia.com.br/api";

console.log("🔥 API_URL HARDCODED:", API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // timeout: 10000,
});

// ================================
// Request interceptor (JWT)
// ================================
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ================================
// Refresh token handling
// ================================
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Se não houver response (ex: erro de rede / CORS)
    if (!error.response) {
      return Promise.reject(error);
    }

    // Trata apenas 401
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = "Bearer " + token;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          localStorage.clear();
          window.location.href = "/";
          return Promise.reject(error);
        }

        // 🔴 IMPORTANTE:
        // endpoint correto em produção
        const resp = await axios.post(
          `${API_URL}/auth/refresh`,
          { refreshToken },
          { headers: { "Content-Type": "application/json" } }
        );

        const newToken = resp.data.token;
        const newRefresh = resp.data.refreshToken;

        localStorage.setItem("token", newToken);
        localStorage.setItem("refreshToken", newRefresh);

        api.defaults.headers.Authorization = "Bearer " + newToken;

        processQueue(null, newToken);

        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
